<template>
  <DataTable
    ref="DataTable"
    :data-model="'templates.genecombinations'"
    :items="genecombinations"
    :loading="loading"
    :permission-name="'Templates'"
    :exclude-fields="['phenotypeEn', 'description', 'descriptionEn', 'combinationGeneCode', 'defaultTemplate', 'defaultTemplateEn', 'references']"
    :allow-create="false"
    :remove-message="$t('ViewGeneCombination.RemoveMessage')"
    :remove-path="'/admin/genecombinations/remove'"
    @reloadData="reload()"
    :display-name-plural="$t('entities.GeneCombination.Plural')"
    :display-name-singular="$t('entities.GeneCombination.Singular')">
    <template #cell(defaultTemplateRisk)="row">
      <p :style="'color:'+colors[row.item.defaultTemplateRisk]">
        {{ $t('TemplateRisk.'+row.item.defaultTemplateRisk) }}
      </p>
    </template>
  </DataTable>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      genecombinations: [],
      loading: true,
      colors: {
        1: '#2ECC40',
        2: '#FF851B',
        3: '#FF4136',
        4: '#0074D9'
      }
    };
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      this.axios
        .get('/admin/genecombinations')
        .then((res) => {
          if (res.status === 200 && res.data.result.length > 0) {
            this.genecombinations = res.data.result;
          } else {
            this.genecombinations = [];
          }
          this.loading = false;
        })
        .catch((err) => Promise.reject(err)).finally(() => {
          this.$refs.DataTable.finishSpinner();
        });
    }
  }
};
</script>
<style scoped></style>
